import React, { useEffect } from "react";
import axiosInstance from "../../server/axios";
import {databaseUrl} from "../../server/server";
import { useState } from "react";
import { Link, useLocation } from 'react-router-dom';

import { Button } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import { DateRange } from 'react-date-range';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale/ko';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

//grid imort
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {borders, width} from '@mui/system';
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
} from '@mui/x-data-grid';
import {
  randomCreatedDate,
  randomTraderName,
  randomId,
  randomArrayItem,
} from '@mui/x-data-grid-generator';
const Receive = () => {
    const location = useLocation(); // 추가된 부분
    const orderboardDay = location.state?.data; // 추가된 부분
    //const [receiveList, setReceiveList] = useState([]);
    const [page, setPage] = useState(1);
    const [method, setMethod] = useState('수향하역');
    const [materialList, setMaterailList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [companyChange, setCompanyChange] = useState(null ?? 'nodata');
    const [companyInputChange, setCompanyInputChange] = useState(null);
    const [note, setNote] = useState('');
    const [detectedOrder, setDetectedOrder] = useState(0);
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const [dateState, setDateState] = useState([
      {
        startDate: yesterday,
        endDate: yesterday,
        key: 'selection'
      }
    ]);
    const [boxes, setBoxes] = useState([]);
    const addBox = () => {
      setBoxes(prev => [...prev, {
         id: Date.now(),
         autocompleteValue: null,  //초기값이 undefined가 아닌 null
         inputValue: '',
         weight: ''
        }]);
    };
    const updateBox = (id, field, value) => {
      setBoxes(prev =>
        prev.map(box =>
          box.id === id ? { ...box, [field]: value } : box
        )
      );
    };
    const deleteBox = (id) => {setBoxes(prev => prev.filter(box => box.id !== id));};
    useEffect(() => {window.scrollTo(0, 0);}, []);
    useEffect(()=>{getReciveList()},[detectedOrder])
    const getReciveList = async () => {
        const ReceiveInfo = await axiosInstance.get(`/orderboard/receiveinfo`);
        const ReceiveList = await axiosInstance.get(`/orderboard/receive?page=${page}&size=${15}`);
        const order = [];
        //console.log(ReceiveList.data.order);
        for(let i = 0; i < ReceiveList.data.order.length; i++){
          const order_company_text = ReceiveList.data.order[i].company.replace(/:apo:/g,"'");
          const material_text = ReceiveList.data.order[i].material.replace(/:apo:/g,"'");
          order.push({
            id:(ReceiveList.data.order[i].id),
            inputdate:ReceiveList.data.order[i].inputdate.substr(0, 10),
            company:order_company_text,
            company_code:ReceiveList.data.order[i].company_code,
            material:material_text,
            material_code:ReceiveList.data.order[i].material_code,
            weight:Number(ReceiveList.data.order[i].weight),
            start_date:new Date(ReceiveList.data.order[i].start_date),
            end_date:new Date(ReceiveList.data.order[i].end_date),
            receive_date:new Date(ReceiveList.data.order[i].receive_date),
            result:ReceiveList.data.order[i].result,
            note:ReceiveList.data.order[i].note,
            method:ReceiveList.data.order[i].method
          });
        }
        setRows([...order]);
  
        const materialList = [];
        for(let i = 0; i < ReceiveInfo.data.materiallist.length; i++){
          materialList.push({
            label:ReceiveInfo.data.materiallist[i]['품명']+`|${ReceiveInfo.data.materiallist[i]['품목코드']}`,
            code:ReceiveInfo.data.materiallist[i]['품목코드']
          });
        }
        const companyList = [];
        for(let i = 0; i < ReceiveInfo.data.companylist.length; i++){
          companyList.push({
            label:ReceiveInfo.data.companylist[i]['거래처명']+`|${ReceiveInfo.data.companylist[i]['코드']}`,
            code:ReceiveInfo.data.companylist[i]['코드']
          });
        }
        setMaterailList([...materialList]);
        setCompanyList([...companyList])
    }
    const submit = async () => {
      if(boxes.length < 1){
        alert('입고 원료 최소 1개 이상 입력 해주세요');
        return;
      }
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      if(today > dateState[0].endDate){
        alert('입고 원료 일정 확인 해주세요');
        return;
      }
      const companyName = companyInputChange.indexOf('|') === -1 ? companyInputChange+'|' : companyInputChange;
      
      const inputmaterial = [];
      for(let i = 0; i < boxes.length; i++){
        if(boxes[i].inputValue === '')continue;

        const checkValue = boxes[i].inputValue.indexOf('|') === -1 ? boxes[i].inputValue+'|' : boxes[i].inputValue;

        inputmaterial.push({
          material: checkValue,
          weight: boxes[i].weight
        })
      }
      const startDate = format(dateState[0].startDate, 'yyyy-MM-dd');
      const endDate = format(dateState[0].endDate, 'yyyy-MM-dd');
      const receiveDate = startDate === endDate ? endDate : '';
      const sendData = await axiosInstance.post(`/orderboard/receive`,{
        companyname : companyName,
        materiallist : inputmaterial,
        startdate : startDate,
        enddate : endDate,
        receivedate : receiveDate,
        note : note,
        method : method
      })
      if(sendData.data === 'ok'){
        getReciveList();
        setCompanyChange('');
        setCompanyInputChange('');
        setNote('');
        setDateState([
          {
            startDate: yesterday,
            endDate: yesterday,
            key: 'selection'
          }
        ]);
        setBoxes([]);
        setMethod('수향하역')
      }else{
        alert('error!!');
      }
    }
    const columnList = [
      { field: 'id', 
        headerName: '번호', 
        width: 100, 
        editable: false 
      },
      { field: 'inputdate', 
        headerName: '접수일', 
        width: 100, 
        editable: false 
      },
      {
        field: 'company',
        headerName: '구매처',
        width: 150,
        align: 'left',
        editable: true,
      },
      {
        field: 'material',
        headerName: '품명',
        width: 200,
        align: 'left',
        editable: true,
      },
      {
        field: 'method',
        headerName: '수령방법',
        width: 100,
        align: 'left',
        editable: true,
      },
      {
        field: 'weight',
        headerName: '수량',
        width: 100,
        type:'number',
        align:'right',
        editable: true,
      },
      {
        field: 'start_date',
        headerName: '입고시작',
        width: 100,
        type:'date',
        align:'right',
        editable: true,
      },
      {
        field: 'end_date',
        headerName: '입고종료',
        type: 'date',
        width: 100,
        align:'center',
        editable: true,
      },
      {
        field: 'receive_date',
        headerName: '수령일',
        type: 'date',
        width: 100,
        align:'center',
        editable: true,
      },
      {
        field: 'note',
        headerName: '기타',
        type: 'string',
        width: 100,
        align:'center',
        editable: true,
      },
      {
        field: 'result',
        headerName: '결과',
        width: 80,
        align:'center',
        editable: true,
        renderCell: (params) => { 
          return (
            <Button variant="outlined" color="secondary">{params.value}</Button> 
          );
        },
        renderEditCell:(params) => {
          return (
            <select name="color" style={{width:'65px',textAlign:'center'}} value={params.value} onChange={(e)=>{
              // Update the value in the cell
              const updatedValue = e.target.value;
                params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: updatedValue,
              });
            }}>
              <option value="O">O</option>
              <option value="X">X</option>
           </select>
          );
        },
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: '저장/삭제',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                sx={{
                  color: 'primary.main',
                }}
                onClick={handleSaveClick(id)}
              />,
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(id)}
                color="inherit"
              />,
            ];
          }
          return [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              className="textPrimary"
              onClick={handleEditClick(id)}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ];
    const [rows, setRows] = useState([]);
    const [rowsLength, setRowsLength] = useState(null);
    const [rowModesModel, setRowModesModel] = useState({});
    
    const handleRowEditStop = (params, event) => { 
      if (params.reason === GridRowEditStopReasons.rowFocusOut) {
        event.defaultMuiPrevented = true;
      }
    };
    const handleEditClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };
    const handleSaveClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
    const handleDeleteClick = (id) => () => {
      if(window.confirm(`글 번호 ${id} 삭제하시겠습니까?`)){
        axiosInstance.get(`${databaseUrl}/orderboard/deletereceive?id=${id}`)
            alert(`번호 ${id} 삭제 됐습니다`);
            setDetectedOrder(detectedOrder + 1);
      }else{
        alert('취소 됐습니다');
      }
    };
    const handleCancelClick = (id) => () => {
      setRowModesModel({
        ...rowModesModel,
        [id]: { mode: GridRowModes.View, ignoreModifications: true },
      });
      const editedRow = rows.find((row) => row.id === id);
      if (editedRow.isNew) {
        setRows(rows.filter((row) => row.id !== id));
      }
    };
    const processRowUpdate = (newRow) => {
      const updatedRow = { ...newRow, isNew: false };
      const oldrow = rows.filter( (row) => {return row.id === newRow.id})[0];
      const objectKeyArr = Object.keys(newRow);
      const updateObj = {};
      for(let i = 0; i < objectKeyArr.length; i++){
        if(oldrow[objectKeyArr[i]] !== updatedRow[objectKeyArr[i]]){
          updateObj[objectKeyArr[i]] = updatedRow[objectKeyArr[i]];
        }
      }
      delete updatedRow.isNew;
      //const utc_time = updatedRow.delivery_date.getTime() + (updatedRow.delivery_date.getTimezoneOffset()*60*1000);
      const updaterow = axiosInstance.post(`${databaseUrl}/orderboard/updatereceive`,{
        updaterow : updatedRow,
        updateobj : updateObj
      })
      return updatedRow;
    };
    
    const handleRowModesModelChange = (newRowModesModel) => {
      setRowModesModel(newRowModesModel);
    };

    const handleMethodChange = (event) => {
      console.log(event.target.value);
      setMethod(event.target.value);
    };

  return (
    <div>
      <div className="order_header">
        <Link to='/Orderboards'  state={{ data: orderboardDay}} >
          <Button variant="outlined" color="secondary" sx={{height:'100%'}}>
          Back to Orderboards
          </Button>
        </Link>
      </div>
      <div>
        <table style={{marginLeft:'auto',marginRight:'auto',borderSpacing:'10px'}}>
          <thead>
          <tr><th colSpan={3}>원료 입고 일정 입력</th></tr>
          <tr>
            <th>
              수령방법
            </th>
            <th>
              회사 & 수령제품
            </th>
            <th>
              입고 정보
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <Select
              value={method}
              onChange={handleMethodChange}
              defaultValue={'수향하역'}
              inputProps={{ 'aria-label': 'Without label' }}
              >
              <MenuItem value={'수향하역'}>수향하역</MenuItem>
              <MenuItem value={'일산하역'}>일산하역</MenuItem>
              <MenuItem value={'방문수령'}>방문수령</MenuItem>
              <MenuItem value={'아이해피콜'}>아이해피콜</MenuItem>
              <MenuItem value={'삼영물류'}>삼영물류</MenuItem>
              </Select>
            </td>
            <td>
              <Autocomplete
              freeSolo={true}
              disablePortal
              id='companyname'
              options={companyList}
              sx={{ 
              width: 400,
              imeMode:'inactive'
              }}
              renderInput={(params) => <TextField {...params} color="primary" label="구매 회사" />}
              value={companyInputChange}
              onChange={(event, newValue) => {
              setCompanyChange(newValue);
              }}
              onInputChange={(event, newInputValue) => {
              setCompanyInputChange(newInputValue);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            </td>
            <td>
              <TextField
                label="수령장소 또는 주소 시간 등등"
                variant="outlined"
                value={note}
                onChange={(event, value) => {
                  setNote(event.target.value);
                }}
              />
            </td>
            <td>
            <Button variant="outlined" color="secondary" sx={{height:'100%'}}
              onClick={addBox}
              > 원료<br></br>
                추가
              </Button>
            </td>
          </tr>
          {boxes.map((box, index) => (
              <tr key={box.id}>
                <td>{index + 1}</td>
                <td>
                  <Autocomplete
                    freeSolo
                    disablePortal
                    id={String(Date.now())}
                    options={materialList}
                    sx={{ width: 400, imeMode: 'inactive' }}
                    renderInput={(params) => (
                      <TextField {...params} label="입고(수령)원료" />
                    )}
                    value={box.autocompleteValue}
                    onChange={(event, newValue) => {
                      updateBox(box.id, 'autocompleteValue', newValue);
                    }}
                    inputValue={box.inputValue}
                    onInputChange={(event, newInputValue) => {
                      updateBox(box.id, 'inputValue', newInputValue);
                    }}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  />
                </td>
                <td>
                  <TextField
                    label="무게"
                    type="number"
                    variant="outlined"
                    value={box.weight}
                    onChange={(e) =>
                      updateBox(box.id, 'weight', e.target.value)
                    }
                  />
                </td>
                <td>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => deleteBox(box.id)}
                  >
                    삭제
                  </Button>
                </td>
              </tr>
            ))}

            <tr>
              <td colSpan={3}>
              <DateRange
                locale={ko}
                editableDateInputs={true}
                onChange={item => setDateState([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={dateState}
              />
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colSpan={3}>
                <Button 
                variant="outlined"
                color="success"
                style={{width:'100%'}}
                onClick={()=>submit()}
                >
                  전송
                </Button>
              </td>
            </tr>
            </tfoot>
        </table>
      </div>
      <Box
      sx={{
        minHeight:'1000px',
        width: '100%',
        '& .actions': {
          color: 'text.secondary',
        },
        '& .textPrimary': {
          color: 'text.primary',
        },
      }}
      >
    <DataGrid
      container spacing={0}
      sx={{
        fontSize:14,
        border:1,
        centerColumn:'primary.main'
      }}
      autoHeight
      rows={rows}
      columns={columnList}
      editMode="row"
      rowModesModel={rowModesModel}
      onRowModesModelChange={handleRowModesModelChange}
      onRowEditStop={handleRowEditStop}
      disableColumnSorting
      disableColumnFilter 
      hideFooter
      processRowUpdate={processRowUpdate}
    />
   </Box>
    </div>
  )
}
export default Receive;